import React from 'react';
import { string } from 'prop-types';

import * as helpers from './helpers';

const CompaniesIcon = ({ color, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props} fill={color} >
    <path
      d="M15.8333 1.66663H7.5C6.58083 1.66663 5.83333 2.41413 5.83333 3.33329V8.33329H4.16667C3.2475 8.33329 2.5 9.08079 2.5 9.99996V17.5C2.5 17.96 2.8725 18.3333 3.33333 18.3333H10H16.6667C17.1275 18.3333 17.5 17.96 17.5 17.5V3.33329C17.5 2.41413 16.7525 1.66663 15.8333 1.66663ZM4.16667 9.99996H6.66667H9.16667V11.6666V13.3333V16.6666H4.16667V9.99996ZM15.8333 16.6666H10.8333V13.3333V11.6666V9.99996C10.8333 9.08079 10.0858 8.33329 9.16667 8.33329H7.5V3.33329H15.8333V16.6666Z"
      fill={color}
    />
    <path
      d="M9.16683 5H10.8335V6.66667H9.16683V5ZM12.5002 5H14.1668V6.66667H12.5002V5ZM12.5002 8.35917H14.1668V10H12.5002V8.35917ZM12.5002 11.6667H14.1668V13.3333H12.5002V11.6667ZM5.8335 11.6675H7.50016V13.3342H5.8335V11.6675Z"
      fill={color}
    />
  </svg>
);

CompaniesIcon.propTypes = {
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

CompaniesIcon.defaultProps = {
  ...helpers.getDefaultIconDimensionsProps(20, 20),
  ...helpers.getViewBoxProperty({ width: 20, height: 20 }),
};

export default CompaniesIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/companies.js